// Утилита для форматирования текста с поддержкой простого markdown-подобного синтаксиса

export const escapeHtml = (str: string): string =>
  str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export const formatTextForDisplay = (text: string): string => {
  if (!text) return '';

  // Литерал \n (два символа) от модели приводим к переносу строки
  let normalized = escapeHtml(text).replace(/\\n/g, '\n');
  // Разбиваем текст на строки для обработки списков
  const lines = normalized.split('\n');
  const result: string[] = [];
  let inBulletList = false;

  for (let i = 0; i < lines.length; i++) {
    let line = lines[i];

    // Обработка инлайн-форматирования
    line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    line = line.replace(/\*(.*?)\*/g, '<em>$1</em>');
    line = line.replace(/__(.*?)__/g, '<u>$1</u>');
    line = line.replace(/\[align:left\]/g, '<div style="text-align: left;">');
    line = line.replace(/\[align:center\]/g, '<div style="text-align: center;">');
    line = line.replace(/\[align:right\]/g, '<div style="text-align: right;">');

    // Маркированный список (- текст)
    const bulletMatch = line.match(/^-\s+(.+)$/);
    if (bulletMatch) {
      if (!inBulletList) {
        result.push('<ul>');
        inBulletList = true;
      }
      result.push(`<li>${bulletMatch[1]}</li>`);
      continue;
    }

    // Если были в списке, закрываем его
    if (inBulletList) {
      result.push('</ul>');
      inBulletList = false;
    }

    // Нумерованный список (1. текст, 2. текст) — без жирного, только отступ
    const numberedMatch = line.match(/^(\d+)\.\s+(.+)$/);
    if (numberedMatch) {
      result.push(`<div style="margin-top: 4px;">${numberedMatch[1]}. ${numberedMatch[2]}</div>`);
      continue;
    }

    // Подзаголовки (Результаты:)
    if (/^(Результаты:)$/.test(line)) {
      result.push(`<div style="font-weight: 600; margin-top: 8px;">${line}</div>`);
      continue;
    }

    // Обычная строка
    if (line.trim() === '') {
      result.push('<br>');
    } else {
      result.push(`${line}<br>`);
    }
  }

  // Закрываем список если остался открытым
  if (inBulletList) {
    result.push('</ul>');
  }

  return result.join('');
};

export const formatTextForPlain = (text: string): string => {
  if (!text) return '';

  let formatted = text;

  // Убираем форматирование для plain text
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '$1');
  formatted = formatted.replace(/\*(.*?)\*/g, '$1');
  formatted = formatted.replace(/__(.*?)__/g, '$1');
  formatted = formatted.replace(/\[align:(left|center|right)\]/g, '');

  return formatted;
};